import { RootState } from "../../rootState";

export const contextSelector = (state: RootState) =>
    state.changes.workspaceChanges && state.changes.workspaceChanges.context;
export const viewSelector = (state: RootState) => state.changes.workspaceChanges && state.changes.workspaceChanges.view;
